import { Box, Typography } from "@mui/material";
import MaterialTable from "material-table";
import { dataCell, dataHeader, defaultTableOptions, tableIcons, textCell, textHeader } from "../../shared/tableHelper";

const CyberTrainingEmployeeTable = (props) => {
	
	const handleEmployeeClick = (event, employee) => {
		props.onEmployeeClick(employee);
	};
	
	return (
		<Box sx={{width: "100%", margin: "auto"}}>
			{(props.companyEmployees && props.companyEmployees.length > 0)?
				<MaterialTable
					icons={tableIcons}
					columns={[
						{
							title: "Firstname",
							field: "firstname",
							cellStyle: textCell,
							headerStyle: textHeader
						},
						{
							title: "Lastname",
							field: "lastname",
							cellStyle: textCell,
							headerStyle: textHeader
						},
						{
							title: "Courses Enrolled",
							field: "courses.length",
							cellStyle: dataCell,
							headerStyle: dataHeader,
							render: (employee) => {
								return <Typography>{`${employee.courses.length}`}</Typography>
							}
						},
						{
							title: "Courses Started",
							field: "courseStats.coursesStarted",
							cellStyle: dataCell,
							headerStyle: dataHeader,
							render: (employee) => {
								return <Typography>
									{`${(employee.courseStats)? employee.courseStats.coursesStarted : "-"}`}
								</Typography>
							}
						},
						{
							title: "Courses Completed",
							field: "courseStats.coursesCompleted",
							cellStyle: dataCell,
							headerStyle: dataHeader,
							render: (employee) => {
								return <Typography>
									{`${(employee.courseStats)? employee.courseStats.coursesCompleted : "-"}`}
								</Typography>
							}
						},
						{
							title: "Avg. Completion Days From Start",
							field: "courseStats.averageCompletionDaysFromStart",
							cellStyle: dataCell,
							headerStyle: dataHeader,
							render: (employee) => {
								return <Typography>
									{`${(employee.courseStats)?
										employee.courseStats.averageCompletionDaysFromStart.toFixed(2) : "-"}`}
								</Typography>
							}
						},
						{
							title: "Avg. Completion Days From Enrollment",
							field: "courseStats.averageCompletionDaysFromEnrol",
							cellStyle: dataCell,
							headerStyle: dataHeader,
							render: (employee) => {
								return <Typography>
									{`${(employee.courseStats)?
										employee.courseStats.averageCompletionDaysFromEnrol.toFixed(2) : "-"}`}
								</Typography>
							}
						},
						{
							title: "Average Grade",
							field: "courseStats.averageGrade",
							cellStyle: dataCell,
							headerStyle: dataHeader,
							render: (employee) => {
								return <Typography>
									{`${(employee.courseStats)? employee.courseStats.averageGrade : "-"}`}
								</Typography>
							}
						},
					]}
					data={props.companyEmployees}
					title=""
					onRowClick={handleEmployeeClick}
					options={defaultTableOptions}
				/>
			: <MaterialTable icons={tableIcons} title="" options={defaultTableOptions}/>}
		</Box>
	);

}

export default CyberTrainingEmployeeTable;